import { useQuery } from '@hooks/reactQuery';

import { getOrganisationProjectMembers } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_MEMBERS } from '@constants/queryKeys';

interface IUseQueryProjectMembersReturned {
	projectMembers: TNameTitleValueLabel[];
	isLoadingProjectsMembers: boolean;
}

export const useQueryOrganisationProjectMembers = (organizationId?: string): IUseQueryProjectMembersReturned => {
	const {
		data: projectMembers,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_MEMBERS, { organizationId }],
		queryFn: extractQueryParams(getOrganisationProjectMembers),
		enabled: [organizationId],
		allowedRoles: [
			EUserRoles.assetOwnerOrganizationAdministrator,
			EUserRoles.networkOperatorOrganizationAdministrator,
			EUserRoles.assetConsumerOrganizationAdministrator,
		],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectMembers: projectMembers || [],
		isLoadingProjectsMembers: isInitialLoading || isFetching,
	};
};
